module.exports = __webpack_public_path__ + "img/clownfish.0a076a67.png";